export const Footer = () => {
  return (
    <div className="py-3  text-center bg-slate-500 text-white dark:bg-slate-700  absolute bottom-0 left-0 w-[100%] ">
      &copy; 2024 Food Delivery App
    </div>
  );
};
